import React from 'react';
import { useTranslation } from 'react-i18next';
import { AudioDevice } from '../../hooks/settings/audio-device.types';
import controlStyles from './MicrophoneSettingsControls.module.css';

interface MicrophoneInputSectionProps {
  audioInputs: AudioDevice[];
  selectedInput: string;
  isTestingMic: boolean;
  micLevel: number;
  onInputChange: (deviceId: string) => void;
  onMicTestToggle: () => void;
}

export function MicrophoneInputSection({
  audioInputs,
  selectedInput,
  isTestingMic,
  micLevel,
  onInputChange,
  onMicTestToggle,
}: MicrophoneInputSectionProps) {
  const { t } = useTranslation();

  return (
    <div className={controlStyles.section}>
      <label className={controlStyles.label}>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
        </svg>
        {t('settings:mic.microphone')}
      </label>
      <select
        className={controlStyles.select}
        value={selectedInput}
        onChange={(e) => onInputChange(e.target.value)}
      >
        {audioInputs.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label}
          </option>
        ))}
      </select>

      <div className={controlStyles.micTest}>
        <button
          className={`${controlStyles.testButton} ${isTestingMic ? controlStyles.active : ''}`}
          onClick={onMicTestToggle}
        >
          {isTestingMic ? t('settings:mic.stopTest') : t('settings:mic.testMicrophone')}
        </button>
        <div className={controlStyles.levelMeter}>
          <div className={controlStyles.levelBar} style={{ width: `${micLevel}%` }} />
        </div>
      </div>
    </div>
  );
}
